import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";

import "./checkout.scss";
import Stapper from "../../components/stapper/Stapper";
import {
  Stack,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Backdrop,
  CircularProgress,
  useMediaQuery,
} from "@mui/material";
import BottomDialog from "../../components/bottomDialog/BottomDialog";
import ManageAddress from "../user/addressBook/manageAddress/ManageAddress";

import { useNavigate } from "react-router-dom";
import OrderSummary from "./orderSummary/OrderSummary";
import CartCard from "../../components/cartCard/CartCard";
import AddressSummary from "./addressSummary/AddressSummary";
import AddressCard from "../../components/addressCard/AddressCard";
import PaymentType from "./paymentType/PaymentType";
import authStore from "../../store/authStore";
import cartStore from "../../store/cartStore";
import NoAddressFound from "../../components/noAddressFound/NoAddressFound";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import addressStore from "../../store/addressStore";
import productStore from "../../store/productStore";
import { LoadingButton } from "@mui/lab";
import couponStore from "../../store/couponStore";
import paymentGetWayStore from "../../store/paymentGetWayStore";
import snackbarStore from "../../store/snackbarStore";
import SnackbarAlert from "../../components/snackbarAlert/snackbarAlert";
import paymentStore from "../../store/paymentStore";
import orderStore from "../../store/orderStore";
import ReactPixel from "react-facebook-pixel";

// Icon
import ArrowBackIosRoundedIcon from "@mui/icons-material/ArrowBackIosRounded";
import Successfully from "../../assets/order-successfully.svg";
import orderDeliveryStatusTimeStore from "../../store/orderDeliveryStatusTimeStore";
import MyLoader from "../../components/myLoader/MyLoader";
import { ENV } from "../../constant";
import SEO from "components/seo/SEO";

const steps = ["Cart", "Billing & address", "Payment"];

const Checkout = () => {
  const isNonMobile = useMediaQuery("(max-width: 600px)");
  const AuthStore = authStore();
  const CartStore = cartStore();
  const AddressStore = addressStore();
  const ProductStore = productStore();
  const CouponStore = couponStore();
  const PaymentGetWayStore = paymentGetWayStore();
  const PaymentStore = paymentStore();
  const OrderStore = orderStore();
  const SnackbarStore = snackbarStore();
  const OrderDeliveryStatusTimeStore = orderDeliveryStatusTimeStore();

  const navigate = useNavigate();
  const [activeStep, setActiveStep] = useState(0);
  const [selectPaymentType, setSelectPaymentType] = useState();
  const [isOpenBottomDialog, setIsOpenBottomDialog] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [openDialogCash, setOpenDialogCash] = useState(false);

  const handleCloseCash = () => {
    setOpenDialogCash(false);
  };

  const onDialogClose = () => {
    if (!isLoading) {
      setIsOpenBottomDialog(false);
      AddressStore.clearAddressForm();
    }
  };

  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);

  const nextStep = async () => {
    if (activeStep === 0) {
      if (ENV === "production") {
        ReactPixel.track("InitiateCheckout", {
          value: CartStore.cartProduct.length,
          currency: "INR",
          contents: CartStore.cartProduct.map((item) => ({
            id: item._id,
            quantity: item.qty,
          })),
        });
      }
    }
    if (activeStep !== 2) {
      setActiveStep(activeStep + 1);
      window.scrollTo({ top: 0 });
    } else {
      if (selectPaymentType) {
        if (selectPaymentType === "online") {
          const data = await PaymentGetWayStore.onlinePayment({
            totalAmount: CartStore.totalAmount,
          });

          if (data) {
            await PaymentGetWayStore.initPayment({ data });
          }
        } else if (selectPaymentType === "cash") {
          setOpenDialogCash(true);
        }
      } else {
        SnackbarStore.setMassage({ value: "Select Payment Type" });
        SnackbarStore.setIsOpen({ value: true });
      }
    }
  };

  const cashPayment = async () => {
    PaymentStore.setIsPaymentLoading({ value: true });
    const paymentID = await PaymentStore.createPayment({
      razorpay_order_id: null,
      razorpay_payment_id: null,
      razorpay_signature: null,
      paymentType: "cash",
    });
    const orderDeliveryStatusTimeID =
      await OrderDeliveryStatusTimeStore.createOrderDeliveryStatusTime();

    for (let i = 0; i < CartStore.cartProduct.length; i++) {
      let purchasePrice = 0;
      for (let j = 0; j < ProductStore.mProduct.length; j++) {
        if (
          CartStore.cartProduct[i].productID === ProductStore.mProduct[j]._id
        ) {
          if (ProductStore.mProduct[j].salePrice) {
            purchasePrice = ProductStore.mProduct[j].salePrice;
          } else {
            purchasePrice = ProductStore.mProduct[j].regularPrice;
          }
          break;
        }
      }
      await OrderStore.createOrder({
        productID: CartStore.cartProduct[i].productID,
        // selectedSize: CartStore.cartProduct[i].selectedSize,
        // selectedColor: CartStore.cartProduct[i].selectedColor,
        quantity: CartStore.cartProduct[i].qty,
        purchasePrice,
        paymentID,
        orderDeliveryStatusTimeID,
      });
    }
    if (CartStore.couponAmount !== 0) {
      await CouponStore.usedCoupon({ _id: CouponStore.copyCouponCode._id });
    }
    if (ENV === "production") {
      ReactPixel.track("Purchase", {
        value: CartStore.totalAmount,
        currency: "INR",
        contents: CartStore.cartProduct.map((item) => ({
          id: item._id,
          quantity: item.qty,
        })),
      });
    }
    await CartStore.whenOrderCartEmpty();
    PaymentStore.setIsPaymentLoading({ value: false });
    OrderStore.setIsOrderSuccessfully({ value: true });
  };

  const backStep = () => {
    if (activeStep === 0) {
      navigate(-1);
    } else {
      setActiveStep(activeStep - 1);
      window.scrollTo({ top: 0 });
    }
  };

  useEffect(() => {
    return () => {
      if (CartStore.cartProduct === null) {
        CouponStore.setCopyCouponCode({ code: null });
        CartStore.setAmount({ name: "couponAmount", value: 0 });
        CouponStore.clearApplyCouponCode();
      }
    };
  }, [CartStore.cartProduct]);

  const createNewAddress = async () => {
    setIsLoading(true);
    const flag = await AddressStore.checkValidation();
    if (flag) {
      await AddressStore.createNewUserAddress();
      setIsOpenBottomDialog(false);
      AddressStore.clearAddressForm();
    }
    setIsLoading(false);
  };

  return (
    <div className="checkout">
      <SEO
        title="Checkout | KRISTIVE"
        description="Complete your purchase with ease. Secure and streamlined checkout process for your favorite luxury fragrances."
      />
      {/* alert ,backdrop, cash order dialog, order successfully */}
      <SnackbarAlert
        isOpen={SnackbarStore.isOpen}
        onClose={() => {
          SnackbarStore.setIsOpen({ value: false });
          SnackbarStore.setMassage({ value: "" });
        }}
        alertVariant="filled"
        alertSeverity="error"
        alertColor="error"
        massage={SnackbarStore.massage}
      />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={PaymentStore.isPaymentLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Dialog
        open={openDialogCash}
        onClose={handleCloseCash}
        className="dialog"
      >
        <DialogTitle>Place Order</DialogTitle>
        <DialogContent>
          <DialogContentText>
            You went to place order with cash on delivery.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseCash}>Cancel</Button>
          <Button
            onClick={async () => {
              setOpenDialogCash(false);
              await cashPayment();
            }}
          >
            Proceed
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={OrderStore.isOrderSuccessfully}
        onClose={() => OrderStore.setIsOrderSuccessfully({ value: false })}
        className="dialog"
        fullWidth
        maxWidth="xs"
        sx={{
          transition: "all 0.5s ease",
        }}
      >
        <DialogContent>
          <Stack className="main-content-dialog" direction="column" spacing={2}>
            <Box
              component="div"
              sx={{
                display: "flex",
                justifyContent: "center",
                transition: "all 0.5s ease",
              }}
            >
              <Box
                component="img"
                src={Successfully}
                alt="successfully"
                sx={{
                  width: "200px",
                  height: "200px",
                  transition: "all 0.5s ease",
                }}
              />
            </Box>
            <p
              style={{
                display: "flex",
                // background: "#171717",
                justifyContent: "center",
                width: "100%",
                transition: "all 0.5s ease",
                fontSize: "25px",
                textAlign: "center",
                fontWeight: 600,
              }}
            >
              Order Successfully
            </p>
            <Button
              variant="contained"
              style={{
                background: "#171717",
                fontWeight: 700,
                letterSpacing: "3px",
              }}
              onClick={() => {
                OrderStore.setIsOrderSuccessfully({ value: false });
                navigate("/user/my-orders");
              }}
            >
              <p>View Order</p>
            </Button>
          </Stack>
        </DialogContent>
      </Dialog>

      {/* alert ,backdrop, cash order dialog, order successfully */}

      {CartStore.isLoading ? (
        <MyLoader height="70vh" />
      ) : CartStore.cartProduct ? (
        <div>
          <div className="checkout-title">
            <h2>Checkout</h2>
          </div>
          <div className="stapper">
            <Stapper steps={steps} activeStep={activeStep} />
          </div>
          <div className="stapper-view-container">
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={8} lg={8}>
                <div className="left-side-checkout">
                  {activeStep === 0 && (
                    <div className="cart single-stapper-view">
                      <Button
                        className="continue-shopping back"
                        onClick={backStep}
                        startIcon={<ArrowBackIosRoundedIcon className="icon" />}
                      >
                        <p>Continue Shopping</p>
                      </Button>
                      {ProductStore.mProduct &&
                        CartStore.cartProduct &&
                        CartStore.cartProduct.length &&
                        CartStore.cartProduct
                          .slice(0)
                          .reverse()
                          .map((item) => (
                            <CartCard key={item.productID} item={item} />
                          ))}
                    </div>
                  )}
                  {activeStep === 1 && (
                    <div className="billing-address single-stapper-view">
                      <div className="btn-container">
                        <Button
                          className="back"
                          onClick={backStep}
                          startIcon={
                            <ArrowBackIosRoundedIcon className="icon" />
                          }
                        >
                          <p>Back</p>
                        </Button>
                        <Button
                          className="new-address-btn"
                          startIcon={<AddRoundedIcon />}
                          onClick={() => {
                            setIsOpenBottomDialog(true);
                          }}
                        >
                          <p>New Address</p>
                        </Button>
                      </div>
                      <div className="dialog">
                        <BottomDialog
                          open={isOpenBottomDialog}
                          onClose={onDialogClose}
                          isDialogAction={true}
                          disabled={isLoading}
                          dialogAction={
                            <DialogActions sx={{ background: "#f5f5f5" }}>
                              <Button
                                color="error"
                                variant="outlined"
                                onClick={onDialogClose}
                                disabled={isLoading}
                                sx={{
                                  transition: " all 0.5s ease",
                                  fontWeight: 700,
                                }}
                              >
                                <p>Cancel</p>
                              </Button>
                              <LoadingButton
                                loading={isLoading}
                                style={{
                                  background: isLoading
                                    ? "#fff"
                                    : "var(--blackColor)",
                                  transition: " all 0.5s ease",
                                  fontWeight: 700,
                                }}
                                variant="contained"
                                onClick={createNewAddress}
                              >
                                <p>Create Address</p>
                              </LoadingButton>
                            </DialogActions>
                          }
                        >
                          <ManageAddress isBtnContainer={false} />
                        </BottomDialog>
                      </div>

                      {AddressStore.myAddress ? (
                        <>
                          {AddressStore.myAddress.map((item) => {
                            if (
                              item.removeAddress === false &&
                              item.useDefault === true
                            ) {
                              return (
                                <AddressCard
                                  isDeliverBtn={true}
                                  nextStep={nextStep}
                                  key={item._id}
                                  item={item}
                                />
                              );
                            }
                          })}
                          {AddressStore.myAddress.map((item) => {
                            if (
                              item.removeAddress === false &&
                              item.useDefault === false
                            ) {
                              return (
                                <AddressCard
                                  isDeliverBtn={true}
                                  nextStep={nextStep}
                                  key={item._id}
                                  item={item}
                                />
                              );
                            }
                          })}
                        </>
                      ) : (
                        <Box
                          component="div"
                          sx={{ m: "5px", mt: 2, transition: "all 0.5s ease" }}
                        >
                          <NoAddressFound />
                        </Box>
                      )}
                    </div>
                  )}
                  {activeStep === 2 && (
                    <div className="payment single-stapper-view">
                      <Button
                        className="back"
                        onClick={backStep}
                        startIcon={<ArrowBackIosRoundedIcon className="icon" />}
                      >
                        <p>Back</p>
                      </Button>
                      <PaymentType
                        selectPaymentType={selectPaymentType}
                        setSelectPaymentType={setSelectPaymentType}
                      />
                    </div>
                  )}
                </div>
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={4}>
                <div className="right-side-checkout">
                  {activeStep === 2 && <AddressSummary />}
                  <OrderSummary activeStep={activeStep} nextStep={nextStep} />
                </div>
              </Grid>
            </Grid>
          </div>
        </div>
      ) : (
        <div className="no-cart-product">
          <div className="title">Your cart is currently empty</div>
          <div className="sub-description">
            Why not return to our amazing shop and start filling it with
            product. Just click on the button below to instantly get back to the
            shop page. Oh, and while you're there, check out all of our
            mind-blowing product.
          </div>
          <div className="btn-container">
            <Button
              className="btn"
              variant="contained"
              onClick={() => {
                navigate("/");
              }}
            >
              <p>Return to Shop</p>
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Checkout;
